import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';

export interface AcertoHoraDTO {
  id?: number;
  folhaServicoId?: number;
  usuario?: string;
  nomeUsuario?: string;
  veiculo?: number | null;
  papeleta?: number;
  data?: string | null;
  nsr?: number;
  hora?: string;
  statusAcertoHora?: string;
  motivoAcertoHoraId?: number;
  excluido?: boolean;
  origem?: string;
  persistente?: boolean;
  offline?: boolean;           // true = offline, false = online
  coletorMarcacao?: string;    // '01' = app nativo, '02' = web
  inSituacao?: string;
  divergente?: boolean;
  usuarioMarcouDivergenteNome?: string;
  dataMarcacaoDivergente?: string;
  horaMarcacaoDivergente?: string;
  observacaoTrafego?: string;

}


export interface MotivoAcertoHora {
  id: number;
  descricao: string;
}

// Nova interface para o acerto com informações completas
export interface AcertoHorarioDTO {
  acertoId: number;
  horaAcerto: string;
  motivoAcertoHoraId: number | null;
  descricaoMotivo: string | null;
  status: string;
  usuarioAcerto: string;
  dataAcerto: string;
  excluido: boolean;
  divergente?: boolean;
  usuarioMarcouDivergenteNome?: string;
  dataMarcacaoDivergente?: string;
  horaMarcacaoDivergente?: string;
  usuarioAutorizacao: string;
  dataAutorizacao: string;
  horaAutorizacao: string;
  papeleta: any;


}

// Nova interface para a resposta completa da folha de serviço com acertos
export interface FolhaServicoAcertoResponseDTO {
  folhaServicoId: number;
  motoristaId: number;
  dataServico: string;
  horarioInicial: string;
  horarioFinal1: string;
  horarioInicial2: string;
  horarioFinal: string;
  garagemId: number | null;
  grupoAlocacaoCodigo: number | null;
  turno: number | null;
  papeleta: number;
  numeroVeiculo: string;
  matriculaMotorista: string;
  tipoInatividade: string;
  dataHoraAssinatura: Date;
  acertos: AcertoHorarioDTO[];
  grupoCodigoLinha: number;
  tarefaDupla: number;
  diferencaTelemetria: string;
  checadoTelemetria: boolean;
  usuarioChecouTelemetriaId: number;
  usuarioChecouTelemetriaNome: string;
  dataChecagemTelemetria: string;
  horaChecagemTelemetria: string;
  marcadoFalta: boolean;
  usuarioMarcouFaltaId: number;
  usuarioMarcouFaltaNome: string;
  dataMarcacaoFalta: string;
  horaMarcacaoFalta: string;
  descricaoJornada: string;
  marcadoFaltaIntervalo: boolean;
  usuarioMarcouFaltaIntervaloId: number;
  usuarioMarcouFaltaIntervaloNome: string;
  dataMarcacaoFaltaIntervalo: string;
  horaMarcacaoFaltaIntervalo: string;
  observacao?: string;
  observacaoTrafego?: string;
  nomeMotorista?: string;
  motivoInatividade?: string;
  marcadoInatividade?: boolean;
  usuarioMarcadoInatividadeNome?: string;
  dataMarcadoInatividade?: string;
  horaMarcadoInatividade?: string;
  usuarioCriouBranco?: string;
  observacaoPlanejamento?: string;

}

// Interface para os filtros
export interface AcertoFiltros {
  dataInicio?: string;
  dataFim?: string;
  turno?: number;
  motorista?: string;
  veiculo?: string;
  grupoAlocacaoCodigo?: number;
  garagemId?: number;
  apenasSemAcertos?: boolean;
  apenasNaoChecados?: boolean;
  apenasPendentes?: boolean;
  apenasFaltaAssinatura?: boolean;
  apenasComObservacaoNaoChecada?: boolean;
  papeletasExternas?: boolean;
  apenasMarcadoDivergente?: boolean;
  horaRequisicao?: string;
  intervaloHoras?: number;
}

@Injectable({
  providedIn: 'root'
})
export class AcertoHoraService {

  constructor(private http: HttpClient) { }

  listarTodos(): Observable<AcertoHoraDTO[]> {
    return this.http.get<AcertoHoraDTO[]>(`/acerto-hora/todos`);
  }

  listar(folhaServicoId: number, usuarioId: number): Observable<AcertoHoraDTO[]> {
    return this.http.get<AcertoHoraDTO[]>(`/acerto-hora/${folhaServicoId}/${usuarioId}`);
  }

  salvar(acertos: AcertoHoraDTO[]): Observable<AcertoHoraDTO[]> {
    return this.http.post<AcertoHoraDTO[]>(`/acerto-hora`, acertos);
  }

  listarMotivos(): Observable<MotivoAcertoHora[]> {
    return this.http.get<MotivoAcertoHora[]>(`/motivo-acerto-hora`);
  }

  /*listarAcertosCompletos(): Observable<FolhaServicoAcertoResponseDTO[]> {
    return this.http.get<FolhaServicoAcertoResponseDTO[]>(`/acerto-hora/acertos-completos`);
  }*/

  listarAcertosCompletos(filtros?: AcertoFiltros): Observable<FolhaServicoAcertoResponseDTO[]> {
    let params = new HttpParams();

    if (filtros) {
      if (filtros.dataInicio) {
        params = params.set('dataInicio', filtros.dataInicio);
      }
      if (filtros.dataFim) {
        params = params.set('dataFim', filtros.dataFim);
      }
      if (filtros.turno !== undefined && filtros.turno !== null) {
        params = params.set('turno', filtros.turno.toString());
      }
      if (filtros.motorista) {
        params = params.set('motorista', filtros.motorista);
      }
      if (filtros.veiculo) {
        params = params.set('veiculo', filtros.veiculo);
      }
      if (filtros.grupoAlocacaoCodigo !== undefined && filtros.grupoAlocacaoCodigo !== null) {
        params = params.set('grupoAlocacaoCodigo', filtros.grupoAlocacaoCodigo.toString());
      }
      if (filtros.garagemId !== undefined && filtros.garagemId !== null) {
        params = params.set('garagemId', filtros.garagemId.toString());
      }
      if (filtros.apenasSemAcertos !== undefined && filtros.apenasSemAcertos !== null) {
        params = params.set('apenasSemAcertos', filtros.apenasSemAcertos.toString());
      }
      if (filtros.apenasNaoChecados !== undefined && filtros.apenasNaoChecados !== null) {
        params = params.set('apenasNaoChecados', filtros.apenasNaoChecados.toString());
      }
      if (filtros.apenasPendentes !== undefined && filtros.apenasPendentes !== null) {
        params = params.set('apenasPendentes', filtros.apenasPendentes.toString());
      }
      if (filtros.apenasFaltaAssinatura !== undefined && filtros.apenasFaltaAssinatura !== null) {
        params = params.set('apenasFaltaAssinatura', filtros.apenasFaltaAssinatura.toString());
      }
      if (filtros.apenasComObservacaoNaoChecada !== undefined && filtros.apenasComObservacaoNaoChecada !== null) {
        params = params.set('apenasComObservacaoNaoChecada', filtros.apenasComObservacaoNaoChecada.toString());
      }
      if (filtros.papeletasExternas !== undefined && filtros.papeletasExternas !== null) {
        params = params.set('papeletasExternas', filtros.papeletasExternas.toString());
      }
      if (filtros.apenasMarcadoDivergente !== undefined && filtros.apenasMarcadoDivergente !== null) {
        params = params.set('apenasMarcadoDivergente', filtros.apenasMarcadoDivergente.toString());
      }
    }

    return this.http.get<FolhaServicoAcertoResponseDTO[]>(`/acerto-hora/acertos-completos`, { params });
  }

  buscarAcertosPorFolhaServico(folhaServicoId: number): Observable<FolhaServicoAcertoResponseDTO> {
    return this.http.get<FolhaServicoAcertoResponseDTO>(`/acerto-hora/folha/${folhaServicoId}`);
  }

  atualizarChecagemTelemetria(payload: any): Observable<any> {
    return this.http.put(`/acerto-hora/atualizar-checagem-telemetria`, payload);
  }

  atualizarMarcacaoFalta(payload: any): Observable<any> {
    return this.http.put(`/acerto-hora/atualizar-marcacao-falta`, payload);
  }

  atualizarMarcacaoDivergente(payload: any): Observable<any> {
    return this.http.put(`/acerto-hora/atualizar-marcacao-divergente`, payload);
  }

  atualizarMarcacaoFaltaIntervalo(payload: any): Observable<any> {
    return this.http.put(`/acerto-hora/atualizar-marcacao-falta-intervalo`, payload);
  }

  atualizarMarcacaoInatividade(payload: any): Observable<any> {
    return this.http.put(`/acerto-hora/atualizar-marcacao-inatividade`, payload);
  }

  listarAcertosCompletosAExecutar(filtros: AcertoFiltros): Observable<FolhaServicoAcertoResponseDTO[]> {
    let params = new HttpParams();

    // Filtros existentes
    if (filtros.dataInicio) params = params.set('dataInicio', filtros.dataInicio);
    if (filtros.dataFim) params = params.set('dataFim', filtros.dataFim);
    if (filtros.turno) params = params.set('turno', filtros.turno.toString());
    if (filtros.motorista) params = params.set('motorista', filtros.motorista);
    if (filtros.veiculo) params = params.set('veiculo', filtros.veiculo);
    if (filtros.grupoAlocacaoCodigo) params = params.set('grupoAlocacaoCodigo', filtros.grupoAlocacaoCodigo.toString());
    if (filtros.garagemId) params = params.set('garagemId', filtros.garagemId.toString());
    if (filtros.apenasSemAcertos) params = params.set('apenasSemAcertos', filtros.apenasSemAcertos.toString());
    if (filtros.apenasNaoChecados) params = params.set('apenasNaoChecados', filtros.apenasNaoChecados.toString());
    if (filtros.apenasPendentes) params = params.set('apenasPendentes', filtros.apenasPendentes.toString());
    if (filtros.apenasFaltaAssinatura) params = params.set('apenasFaltaAssinatura', filtros.apenasFaltaAssinatura.toString());
    if (filtros.apenasComObservacaoNaoChecada) params = params.set('apenasComObservacaoNaoChecada', filtros.apenasComObservacaoNaoChecada.toString());

    // 🔥 NOVOS PARÂMETROS PARA "A EXECUTAR"
    if (filtros.horaRequisicao) params = params.set('horaRequisicao', filtros.horaRequisicao);
    if (filtros.intervaloHoras) params = params.set('intervaloHoras', filtros.intervaloHoras.toString());

    // 🔥 CORRIGIDO: Use a URL relativa (sem API_URL)
    return this.http.get<FolhaServicoAcertoResponseDTO[]>(
      `/acerto-hora/acertos-completos-a-executar`,
      { params }
    );
  }
}